import { useCallback, useEffect, useState } from 'react';

export function useTextAreaCollapsedState({ collapsed }) {
  const [collapsedState, setCollapsedState] = useState(collapsed);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (collapsed && focused) {
      return;
    }

    setCollapsedState(collapsed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed]);

  const handleFocus = useCallback(() => {
    setCollapsedState(false);
    setFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setFocused(false);

    if (!collapsed) {
      return;
    }

    setCollapsedState(true);
  }, [collapsed]);

  return {
    onFocus: handleFocus,
    onBlur: handleBlur,
    isCollapsed: collapsedState,
  };
}
